import { render, staticRenderFns } from "./PlanDetailBlock.vue?vue&type=template&id=77f558ed&scoped=true"
import script from "./PlanDetailBlock.vue?vue&type=script&lang=js"
export * from "./PlanDetailBlock.vue?vue&type=script&lang=js"
import style0 from "./PlanDetailBlock.vue?vue&type=style&index=0&id=77f558ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f558ed",
  null
  
)

export default component.exports